<!DOCTYPE html>
<div class="modal-wrapper image-wrapper" id="myElement">
  <div class="top-button-bar">
    <div class="wrapper">
      <div (click)="close()"><ion-icon class="close-icon" name="close-circle-outline"></ion-icon></div>
    </div>
  </div>
  <img class="img-1" src="../../../../assets/icon/corner-1.svg" alt="corner-1" />
  <img class="img-1" src="../../../../assets/icon/corner-2.svg" alt="corner-2" />
  <div>

    <div></div>
    <div  class="ion-align-self-center">
      <p class="emoji-gift-cone">
        👍
      </p>
    </div>

    <div  class="content-warper">
      <h2 class="title">Your account is now permanently {{ data }} </h2>
    </div>

    <div  class="back-to-account">
      <ion-button (click)="close()" expand="block" color="medium" class="request-popup-btn  common-margin" type="submit">
        Close
      </ion-button>
    </div>

  </div>
</div>